import React from 'react'
import styled from 'styled-components'

type Props = {
  label: string
  value: string
  placeholder?: string
  error?: string
  onChange: (value: string) => void
  onBlur?: () => void
  maxLength?: number
}

const SimpleTextAreaField = ({
  label,
  value,
  placeholder,
  onChange,
  onBlur,
  error,
  maxLength = 1000,
}: Props) => {
  const overLimit = value.length > maxLength
  const displayError = overLimit ? '最大1000文字までです' : error

  return (
    <FieldWrapper>
      <label>{label}</label>
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className={displayError ? 'error' : ''}
        rows={6}
      />
      <div className="meta">
        <span className={`error-text ${displayError ? 'show' : ''}`}>
          {displayError || '　'}
        </span>
        <span className={`count ${overLimit ? 'over' : ''}`}>
          {value.length}/{maxLength}
        </span>
      </div>
    </FieldWrapper>
  )
}

export default SimpleTextAreaField

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-weight: 800;
    font-size: 16px;
  }

  textarea {
    border: 1px solid #c6b98c;
    border-radius: 10px;
    padding: 10px 14px;
    background-color: white;
    font-size: 16px;
    resize: none;
    font-family: inherit;
    width: 100%;
  }

  textarea.error {
    border-color: #ff4d4f;
  }

  .meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .error-text {
    font-size: 14px;
    color: #ff4d4f;
    line-height: 18px;
    visibility: hidden;
    padding: 0;
    margin: 0;
  }

  .error-text.show {
    visibility: visible;
  }

  .count {
    font-size: 14px;
    color: #7a7a7a;
  }

  .count.over {
    color: #ff4d4f;
    font-weight: 600;
  }
`
